import { t } from '@kb/i18n';
import { IconSymbol } from '@ocp/button';
import eventBus, { EventTypes } from '@ocp/event-bus';
import { notifyInfo } from '@ocp/notifications';
import i18nKeys from '../i18n/index';
export function shareViaCopy(url) {
    navigator.clipboard
        .writeText(url)
        .then(() => notifyInfo(t(i18nKeys.CONTENT_LINK_COPIED_TO_CLIPBOARD)));
}
export function shareViaEmail() {
    eventBus.fire(EventTypes.ToggleSendByEmailForm);
}
export function shareViaSms() {
    eventBus.fire(EventTypes.ToggleSendBySmsForm);
}
export function getShareButtons(shareButtonsInfo) {
    const buttons = [];
    if (shareButtonsInfo.contentLinkButton) {
        const { order, url } = shareButtonsInfo.contentLinkButton;
        buttons.push({
            order,
            symbol: IconSymbol.Link,
            title: t(i18nKeys.COPY_LINK),
            onClick: () => shareViaCopy(url),
        });
    }
    if (shareButtonsInfo.sendToEmailButton) {
        const { order } = shareButtonsInfo.sendToEmailButton;
        buttons.push({
            order,
            symbol: IconSymbol.KnowMail,
            title: t(i18nKeys.SEND_BY_EMAIL),
            onClick: shareViaEmail,
        });
    }
    if (shareButtonsInfo.sendToSmsButton) {
        const { order } = shareButtonsInfo.sendToSmsButton;
        buttons.push({
            order,
            symbol: IconSymbol.Sms,
            title: t(i18nKeys.SEND_BY_SMS),
            onClick: shareViaSms,
        });
    }
    return buttons;
}
export function getButtonItems(shareButtonsInfo) {
    const items = [];
    if (shareButtonsInfo.contentLinkButton) {
        const contentUrl = shareButtonsInfo.contentLinkButton.url;
        items.push({
            title: t(i18nKeys.COPY_LINK),
            onClick: () => shareViaCopy(contentUrl),
        });
    }
    if (shareButtonsInfo.sendToEmailButton) {
        items.push({
            title: t(i18nKeys.SEND_BY_EMAIL),
            onClick: shareViaEmail,
        });
    }
    if (shareButtonsInfo.sendToSmsButton) {
        items.push({
            title: t(i18nKeys.SEND_BY_SMS),
            onClick: shareViaSms,
        });
    }
    return items;
}
